// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as ApiUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as UrlUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as ErrorUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as RescriptReactRouter from "../../../../node_modules/@rescript/react/src/RescriptReactRouter.bs.js";
import * as TrackLiveTripRepoManager from "../domain/repo/TrackLiveTripRepoManager.bs.js";
import * as Lib$PorterinFusionkitSentry from "../../../../node_modules/@porterin/fusionkit-sentry/src/Lib.bs.js";

function updateTrackingRoute(booking_id, customer_uuid) {
  return RescriptReactRouter.push("/track_live_order?booking_id=" + (booking_id + ("&customer_uuid=" + customer_uuid)));
}

function getSecondUuid(route, first_uuid) {
  var url_params = UrlUtils$Catalyst.getURLParams(route.search);
  var uuid = Belt_Option.getWithDefault(Js_dict.get(url_params, "customer_uuid"), "");
  if (uuid === first_uuid) {
    return ;
  } else {
    return uuid;
  }
}

function getOrderInfo(dispatch, booking_id, customer_uuid, route) {
  var TrackLiveTripRepo = TrackLiveTripRepoManager.getTrackLiveTripRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(TrackLiveTripRepo.fetchTrackLiveTripInfo, booking_id, customer_uuid);
              }), (function (orderInfo) {
                var updated_crn = orderInfo.updated_crn;
                if (updated_crn !== undefined) {
                  getOrderInfo(dispatch, updated_crn, customer_uuid, route);
                  return updateTrackingRoute(updated_crn, customer_uuid);
                } else {
                  return Curry._1(dispatch, {
                              TAG: /* SetOrderInfo */0,
                              _0: orderInfo
                            });
                }
              }), (function (error) {
                var uuid = getSecondUuid(route, customer_uuid);
                if (uuid !== undefined) {
                  return getOrderInfo(dispatch, booking_id, uuid, route);
                } else {
                  Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, "FetchTrackLiveTripInfo API Failed - " + ErrorUtils$Catalyst.resolveError(error));
                  Curry._1(dispatch, {
                        TAG: /* SetOrderInfoError */1,
                        _0: error
                      });
                  return Curry._1(dispatch, {
                              TAG: /* SetAutoReload */5,
                              _0: false
                            });
                }
              }));
}

function getMarketingInfo(dispatch, booking_id, customer_uuid, route) {
  var TrackLiveTripRepo = TrackLiveTripRepoManager.getTrackLiveTripRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(TrackLiveTripRepo.fetchTrackLiveTripMarketingInfo, booking_id, customer_uuid);
              }), (function (marketingInfo) {
                return Curry._1(dispatch, {
                            TAG: /* SetMarketingInfo */2,
                            _0: marketingInfo
                          });
              }), (function (error) {
                var uuid = getSecondUuid(route, customer_uuid);
                if (uuid !== undefined) {
                  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                                return Curry._2(TrackLiveTripRepo.fetchTrackLiveTripMarketingInfo, booking_id, uuid);
                              }), (function (marketingInfo) {
                                return Curry._1(dispatch, {
                                            TAG: /* SetMarketingInfo */2,
                                            _0: marketingInfo
                                          });
                              }), (function (error) {
                                Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, "FetchTrackLiveTripMarketingInfo API Failed -" + ErrorUtils$Catalyst.resolveError(error));
                                Curry._1(dispatch, {
                                      TAG: /* SetMarketingInfoError */3,
                                      _0: error
                                    });
                                return Curry._1(dispatch, {
                                            TAG: /* SetAutoReload */5,
                                            _0: false
                                          });
                              }));
                } else {
                  Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, "FetchTrackLiveTripMarketingInfo API Failed -" + ErrorUtils$Catalyst.resolveError(error));
                  Curry._1(dispatch, {
                        TAG: /* SetMarketingInfoError */3,
                        _0: error
                      });
                  return Curry._1(dispatch, {
                              TAG: /* SetAutoReload */5,
                              _0: false
                            });
                }
              }));
}

export {
  updateTrackingRoute ,
  getSecondUuid ,
  getOrderInfo ,
  getMarketingInfo ,
  
}
/* RescriptReactRouter Not a pure module */
